import { combineReducers } from "redux";
import editor from "./editor";
import tab from "./tab";
import log from "./log";
import submissions from "./submissions";

export default combineReducers({ editor, tab, log, submissions });
